function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.77 44.18a2.62 2.62 0 003.72 0l16.99-17.05 17.03 17.1a2.62 2.62 0 003.72 0 2.65 2.65 0 000-3.74L27.2 23.4 44.02 6.51a2.65 2.65 0 000-3.74 2.62 2.62 0 00-3.72 0L23.48 19.66 6.7 2.82a2.62 2.62 0 00-3.72 0 2.65 2.65 0 000 3.73L19.76 23.4 2.77 40.45a2.65 2.65 0 000 3.73z"
})));